import axios from "axios";

export const state = {
    writtenoffloans: [],
};

export const getters = {
    writtenoffloans: state => state.writtenoffloans,
};

export const mutations = {
    setWrittenOffLoans(state, newValue) {
        state.writtenoffloans = newValue
    },
};

export const actions = {
    async fetchWrittenOffLoans({ commit }) {
        await axios.get('/writtenoffloans').then(res => {
            commit('setWrittenOffLoans', res.data.writtenoffloans)
        })
    },
    async filterWrittenOffLoans({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterwrittenoffloans";
        await axios.post(url, formData).then((response) => {
            commit('setWrittenOffLoans', response.data.writtenoffloans)
        })
    },
};
